import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["onComplete", "onError"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useRef } from 'react';
import { useCrossFlow } from '@atlassiansox/cross-flow-api-internals';
export var CrossFlowConsumer = function CrossFlowConsumer(props) {
  // Using useRef here to ensure that only the initial props are used
  // and it ensures that the useEffect handler below is only run once.
  // Any subsequent changes to props have no effect.
  var propsRef = useRef(props);
  var crossFlowRef = useRef(useCrossFlow());
  useEffect(function () {
    var crossFlow = crossFlowRef.current;
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _propsRef$current, onComplete, onError, options, status;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _propsRef$current = propsRef.current, onComplete = _propsRef$current.onComplete, onError = _propsRef$current.onError, options = _objectWithoutProperties(_propsRef$current, _excluded);
            if (!crossFlow.isEnabled) {
              _context.next = 12;
              break;
            }
            _context.prev = 2;
            _context.next = 5;
            return crossFlow.api.open(options);
          case 5:
            status = _context.sent;
            onComplete === null || onComplete === void 0 || onComplete(status);
            _context.next = 12;
            break;
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);
            onError === null || onError === void 0 || onError(_context.t0);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 9]]);
    }))();
  }, []);
  return null;
};